module.exports = __webpack_public_path__ + "static/media/comments-dollar.368308dc.svg";